/**
 * Утилита для управления spinner'ом возле курсора
 */

let cursorTracker: ((e: MouseEvent) => void) | null = null;

export function showCursorSpinner(x: number, y: number): void {
  const spinner = document.getElementById('cursor-spinner');
  if (spinner) {
    spinner.style.left = `${x + 10}px`;
    spinner.style.top = `${y + 10}px`;
    spinner.classList.add('active');
    
    // Отслеживаем движение курсора
    trackCursor();
  }
}

export function hideCursorSpinner(): void {
  const spinner = document.getElementById('cursor-spinner');
  if (spinner) {
    spinner.classList.remove('active');
    if (cursorTracker) {
      document.removeEventListener('mousemove', cursorTracker);
      cursorTracker = null;
    }
  }
}

function trackCursor(): void {
  if (cursorTracker) {
    document.removeEventListener('mousemove', cursorTracker);
  }
  
  cursorTracker = (e: MouseEvent) => {
    const spinner = document.getElementById('cursor-spinner');
    if (spinner && spinner.classList.contains('active')) {
      spinner.style.left = `${e.clientX + 10}px`;
      spinner.style.top = `${e.clientY + 10}px`;
    }
  };
  
  document.addEventListener('mousemove', cursorTracker);
}

